import { useState } from "react";

const faqs = [
  {
    q: "What makes Ultimate Heating & Cooling different from other HVAC companies?",
    a: "We're locally owned, fully licensed, and have been serving Connecticut homeowners for over 15 years. Our technicians are NATE-certified and never commissioned — they diagnose honestly and recommend only what your system truly needs. No upselling, no surprises.",
  },
  {
    q: "Do you offer financing for new equipment installs?",
    a: "Yes! We partner with approved lenders to offer flexible financing options including 0% APR promotional periods for qualified customers. Whether it's a new furnace, central AC, or full HVAC replacement, we'll work with your budget. Ask about current promotions when you call.",
  },
  {
    q: "How quickly can you respond to emergency calls?",
    a: "We offer emergency service. For urgent heating or cooling failures, our average response time is under 2 hours. We know a broken furnace in January isn't something that can wait — so neither do we.",
  },
  {
    q: "Which brands of equipment do you carry and install?",
    a: "We're certified dealers and installers for Carrier, Lennox, Trane, Bryant, and more. We'll recommend the best system for your home's size, layout, and budget — not just the most expensive option.",
  },
  {
    q: "Do you service equipment you didn't install?",
    a: "Absolutely. Our technicians are trained to work on all major brands regardless of who installed them. We'll diagnose, repair, and tune up any system — and give you a straight assessment of its remaining lifespan.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-[#F0F4FA]">
      <div className="max-w-4xl mx-auto px-5 md:px-6">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
          {/* Left sticky heading */}
          <div className="md:w-64 flex-shrink-0 md:sticky md:top-32">
            <span className="text-[#C8102E] text-xs font-bold tracking-[0.2em] uppercase">FAQ</span>
            <h2 className="text-2xl font-extrabold text-[#0B2447] mt-2 md:mt-3 leading-snug" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Common Questions
            </h2>
            <p className="text-gray-500 text-sm mt-2 md:mt-3 leading-relaxed">
              Still have questions? Our team is a call away.
            </p>
            <a href="tel:9592418524" className="inline-flex items-center gap-2 mt-3 md:mt-5 text-[#C8102E] text-sm font-bold hover:underline cursor-pointer">
              <i className="ri-phone-line"></i> (959)241-8524
            </a>
          </div>

          {/* Right accordion */}
          <div className="flex-1 w-full space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border border-gray-200 rounded-xl bg-white overflow-hidden"
              >
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer group"
                >
                  <span className="text-sm font-semibold text-[#0B2447] group-hover:text-[#C8102E] transition-colors pr-3 leading-snug">
                    {faq.q}
                  </span>
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${open === i ? "bg-[#C8102E] text-white rotate-45" : "bg-gray-100 text-gray-400"}`}>
                    <i className="ri-add-line text-base"></i>
                  </span>
                </button>
                {open === i && (
                  <div className="px-5 md:px-6 pb-4 md:pb-5 border-t border-gray-100">
                    <p className="text-gray-500 text-sm leading-relaxed pt-3 md:pt-4">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
